import { IS_AU_INSTANCE, REACT_APP_API_URL } from "./environmentVariables";
import { request } from "./request";

export const getUserIdendifier = (userAccountId: number | string) =>
  `${userAccountId}${IS_AU_INSTANCE ? "au" : ""}`;

export const trackEvent = (
  eventName: string,
  data:
    | {
        [key: string]: string | number | boolean | null | undefined;
      }
    | undefined = {}
) => {
  request(`${REACT_APP_API_URL}/talentInsights/trackEvent`, {
    method: "POST",
    body: JSON.stringify({
      eventName: `Develop By Criteria - ${eventName}`,
      properties: { isPostHire: true, eventName, ...data },
    }),
  });
};

export const trackDirectReportModalOpened = () => {
  trackEvent("New Direct Report Modal Opened");
};

export const trackUserGuideTabChange = (tabName: string, isSelf: boolean) => {
  trackEvent("User Guide Tab Change", { tabName, isSelf });
};

export const trackTeamGuideTabChange = (
  tabName: string,
  isTeamLeader: boolean
) => {
  trackEvent("Team Guide Tab Change", { tabName, isTeamLeader });
};

export const trackDepartmentGuideTabChange = (
  tabName: string,
  isDepartmentLeader: boolean
) => {
  trackEvent("Department Guide Tab Change", { tabName, isDepartmentLeader });
};

export const trackUserDownloadedAttachment = (
  attachmentType: "Cover Letter" | "Resume"
) => {
  trackEvent("User Job Profile Attachment Downloaded", { attachmentType });
};

export const trackUserViewedEmailManager = () => {
  trackEvent("User Viewed Email Manager");
};

export const trackCSVExport = (exportType: string) => {
  trackEvent("CSV Export", { exportType });
};

export const trackModalOpened = (modalName: string) => {
  trackEvent("Modal Opened", { modalName });
};

export const trackCSVUploadSubmitted = ({
  totalUsersUploaded,
  hasAutomaticTeamsEnabled,
}: {
  totalUsersUploaded: number;
  hasAutomaticTeamsEnabled: boolean | null;
}) => {
  trackEvent("CSV Upload Being Submitted", {
    totalUsersUploaded,
    hasAutomaticTeamsEnabled: !!hasAutomaticTeamsEnabled,
  });
};

export const trackAutomaticTeamsFeatureToggled = (
  isFeatureBeingEnabled: boolean
) => {
  trackEvent("Automatic Teams Feature Toggled", {
    isFeatureBeingEnabled,
  });
};

export const trackFeatureViewed = (
  featureName: string,
  additionalTrackingInformation?: Record<string, string | boolean | number>
) => {
  trackEvent("Feature Viewed", {
    featureName,
    ...additionalTrackingInformation,
  });
};

export const trackGoalSaved = ({ isNewGoal }: { isNewGoal?: boolean } = {}) => {
  trackEvent(`Goal ${isNewGoal ? "Created" : "Updated"}`);
};

export const trackGoalReflectionSaved = ({
  isNewReflection,
}: { isNewReflection?: boolean } = {}) => {
  trackEvent(`Goal Reflection ${isNewReflection ? "Created" : "Updated"}`);
};
